/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc
 */

export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const BrowserLanguagesFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.BrowserLanguagesFilterConfiguration';
export const CityFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.CityFilterConfiguration';
export const CompanyDomainFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.CompanyDomainFilterConfiguration';
export const CompanySizeFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.CompanySizeFilterConfiguration';
export const CountriesFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.CountriesFilterConfiguration';
export const DeviceTypesFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.DeviceTypesFilterConfiguration';
export const FormsSubmittedFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.FormsSubmittedFilterConfiguration';
export const FormsViewedFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.FormsViewedFilterConfiguration';
export const HostFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.HostFilterConfiguration';
export const IndustriesFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.IndustriesFilterConfiguration';
export const IpFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.IpFilterConfiguration';
export const IsContactFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.IsContactFilterConfiguration';
export const IsIdentifiedVisitorFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.IsIdentifiedVisitorFilterConfiguration';
export const LegacyCtasClickedFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.LegacyCtasClickedFilterConfiguration';
export const ListMembershipsFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.ListMembershipsFilterConfiguration';
export const OperatingSystemFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.OperatingSystemFilterConfiguration';
export const PageVisitedFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.PageVisitedFilterConfiguration';
export const PathFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.PathFilterConfiguration';
export const QueryParamsFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.QueryParamsFilterConfiguration';
export const ReferrerFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.ReferrerFilterConfiguration';
export const RegionFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.RegionFilterConfiguration';
export const SessionCountFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.SessionCountFilterConfiguration';
export const TargetingFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.TargetingFilterConfiguration';
export const TechnologiesFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.TechnologiesFilterConfiguration';
export const TimeSinceLastVisitFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.TimeSinceLastVisitFilterConfiguration';
export const TopicsFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.TopicsFilterConfiguration';
export const TopicsHistoryFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.TopicsHistoryFilterConfiguration';
export const UrlFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.UrlFilterConfiguration';
export const WebInteractivesClickedFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.WebInteractivesClickedFilterConfiguration';
export const WebsitePageFilterConfigurationTypename = 'com.hubspot.targeting.models.filters.configuration.WebsitePageFilterConfiguration';
export const AndFilterConfigurationGroupTypename = 'com.hubspot.targeting.models.filters.configuration.groups.AndFilterConfigurationGroup';
export const NotFilterConfigurationGroupTypename = 'com.hubspot.targeting.models.filters.configuration.groups.NotFilterConfigurationGroup';
export const OrFilterConfigurationGroupTypename = 'com.hubspot.targeting.models.filters.configuration.groups.OrFilterConfigurationGroup';
export const createVariantRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'createVariant',
  auth: 'app',
  fingerprint: 'jqNgKBwYz5ENxYg2_XPhwjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalization',
  auth: 'app',
  fingerprint: 'JZhCxIAXXPo4-bu8O4MxSjCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizationStrategyRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizationStrategy',
  auth: 'app',
  fingerprint: 'ojW6h-er-855_hIxQgY7zzCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePersonalizedDefaultRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeContentRpc',
  rpcName: 'deletePersonalizedDefault',
  auth: 'app',
  fingerprint: 'Gq2BAV_gwRePwCyCO6ymWDCO8C2ISrp_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};